import VirtualMachineListSelector from './VirtualMachineListSelector';
import HypervisorListSelector from './HypervisorListSelector';
import { isValidContext, useVirtualInfraContext } from '../InfrastructureUtils';

/**
 * Displays list selector based on virtual infrastructure type
 * Shows VirtualMachineListSelector for hypervisors
 * Shows HypervisorListSelector for vCenters
 */
export default function VirtualTablesSection() {
    const context = useVirtualInfraContext();

    if (!isValidContext(context, true)) {
        return null;
    }

    if (context.isHypervisor) {
        return <VirtualMachineListSelector />;
    }

    if (context.isVCenter) {
        return <HypervisorListSelector />;
    }

    return null;
}
